angular.module('bizmetryApp').controller('DataExplorerDialogController',
    function ($scope, $mdDialog, $filter, DatasourceService, datasource) {
        console.log('🔭 DataExplorerDialogController — datasource:', datasource.datasourceName);

        // =====================================================
        // INIT STATE
        // =====================================================
        $scope.datasource = datasource;
        $scope.schemas = [];
        $scope.loadingSchemas = false;
        $scope.schemasError = false;
        $scope.treeFilter = '';

        $scope.selectedTable = null;   // { schema, name, tableRef }
        $scope.loadingData = false;
        $scope.dataError = false;
        $scope.tableData = { columns: [], rows: [], total: 0 };

        $scope.pagination = {
            limit: 50,
            offset: 0,
            total: 0
        };

        // Objeto (no primitivo): el panel de datos vive dentro de un ng-if con su propio scope
        $scope.dataSearch = { text: '' };
        $scope.highlightTerm = ''; // término de la búsqueda que produjo las filas mostradas
        var loadSequence = 0; // descarta respuestas de búsquedas / páginas ya superadas

        // =====================================================
        // LOAD SCHEMAS
        // =====================================================
        function loadSchemas() {
            $scope.loadingSchemas = true;
            $scope.schemasError = false;
            $scope.schemas = [];

            DatasourceService.getSchemas(datasource.id)
                .then(function (data) {
                    $scope.schemas = (data || []).map(function (s) {
                        var name = typeof s === 'string' ? s : (s.schemaName || s.name || String(s));
                        return {
                            name: name,
                            expanded: false,
                            loadingTables: false,
                            tablesLoaded: false,
                            tables: []
                        };
                    });
                    console.log('✅ [Explorer] Schemas loaded:', $scope.schemas.length);
                    $scope.loadingSchemas = false;
                })
                .catch(function (err) {
                    console.error('❌ [Explorer] Error loading schemas:', err);
                    $scope.loadingSchemas = false;
                    $scope.schemasError = true;
                });
        }

        $scope.reloadSchemas = function () {
            loadSchemas();
        };

        // =====================================================
        // TOGGLE SCHEMA
        // =====================================================
        $scope.toggleSchema = function (schema) {
            schema.expanded = !schema.expanded;

            if (schema.expanded && !schema.tablesLoaded) {
                schema.loadingTables = true;

                DatasourceService.getEntities(datasource.id, schema.name)
                    .then(function (data) {
                        schema.tables = (data || []).map(function (t) {
                            var name = typeof t === 'string' ? t : (t.tableName || t.entityName || t.name || String(t));
                            return {
                                name: name,
                                expanded: false,
                                loadingAttributes: false,
                                attributesLoaded: false,
                                attributes: []
                            };
                        });
                        schema.loadingTables = false;
                        schema.tablesLoaded = true;
                        console.log('✅ [Explorer] Tables loaded for', schema.name, ':', schema.tables.length);
                    })
                    .catch(function (err) {
                        console.error('❌ [Explorer] Error loading tables for', schema.name, ':', err);
                        schema.loadingTables = false;
                    });
            }
        };

        // =====================================================
        // SELECT TABLE
        // El backend requiere al menos una columna en el pull-data,
        // por eso cargamos atributos primero y disparamos loadTableData
        // en el callback — sin race condition.
        // =====================================================
        $scope.selectTable = function (schema, table) {
            var alreadySelected = $scope.isSelectedTable(schema, table);

            if (!alreadySelected) {
                $scope.dataSearch.text = '';
            }
            $scope.selectedTable = { schema: schema.name, name: table.name, tableRef: table };
            $scope.dataError = false;
            $scope.pagination.offset = 0;

            if (!alreadySelected) {
                table.expanded = true;
            }

            if (table.attributesLoaded) {
                // Atributos ya disponibles — pull directo
                loadTableData();
            } else if (!table.loadingAttributes) {
                // Cargar atributos primero; pull cuando terminen
                _loadAttributes(schema, table, function () {
                    loadTableData();
                });
            }
            // Si loadingAttributes === true (doble click rápido) no hacemos nada:
            // el callback del load en curso ya disparará loadTableData
        };

        // Chevron handler — solo expande/colapsa atributos, no cambia la selección
        $scope.toggleTableExpand = function (schema, table, $event) {
            if ($event) $event.stopPropagation();
            table.expanded = !table.expanded;

            if (table.expanded && !table.attributesLoaded && !table.loadingAttributes) {
                _loadAttributes(schema, table, null);
            }
        };

        function _loadAttributes(schema, table, onDone) {
            table.loadingAttributes = true;

            DatasourceService.getAttributes(datasource.id, schema.name, table.name)
                .then(function (data) {
                    // Inicializar visible:true en cada atributo
                    table.attributes = (data || []).map(function (attr) {
                        attr.visible = true;
                        return attr;
                    });
                    table.loadingAttributes = false;
                    table.attributesLoaded = true;
                    console.log('✅ [Explorer] Attributes for', schema.name + '.' + table.name, ':', table.attributes.length);
                    if (typeof onDone === 'function') onDone();
                })
                .catch(function (err) {
                    console.error('❌ [Explorer] Error loading attributes for', table.name, ':', err);
                    table.loadingAttributes = false;
                    // Intentar pull igual para no dejar el panel en blanco
                    if (typeof onDone === 'function') onDone();
                });
        }

        // =====================================================
        // LOAD TABLE DATA
        // Construye columns desde atributos ya cargados —
        // el backend exige al menos una columna en el request.
        // =====================================================
        function loadTableData() {
            if (!$scope.selectedTable) return;

            $scope.loadingData = true;
            $scope.dataError = false;
            $scope.tableData = { columns: [], rows: [], total: 0 };
            var requestId = ++loadSequence;
            var searchText = ($scope.dataSearch.text || '').trim();

            var tableRef = $scope.selectedTable.tableRef;
            var columns = [];
            if (tableRef && tableRef.attributesLoaded && tableRef.attributes.length > 0) {
                columns = tableRef.attributes.map(function (attr, i) {
                    return { sequence: i + 1, columnName: attr.columnName || attr.name || String(attr) };
                });
            }

            DatasourceService.getTableData(
                datasource.id,
                $scope.selectedTable.schema,
                $scope.selectedTable.name,
                columns,
                {
                    limit: Number($scope.pagination.limit),
                    offset: $scope.pagination.offset,
                    orderDirection: 'ASC',
                    searchText: searchText,
                    searchColumns: _visibleColumnNames()
                }
            ).then(function (data) {
                if (requestId !== loadSequence) return;
                $scope.loadingData = false;
                $scope.highlightTerm = searchText;
                _normalizeTableData(data);
                console.log('✅ [Explorer] Data loaded:', $scope.tableData.rows.length, 'rows,', $scope.tableData.columns.length, 'cols');
            }).catch(function (err) {
                if (requestId !== loadSequence) return;
                console.error('❌ [Explorer] Error loading data:', err);
                $scope.loadingData = false;
                $scope.dataError = true;
            });
        }

        // =====================================================
        // NORMALIZE RESPONSE
        // =====================================================
        function _normalizeTableData(data) {
            if (!data) { $scope.tableData = { columns: [], rows: [], total: 0 }; return; }

            // Shape real de la API: { columns: [{sequence,columnName,dataType}], rows: [...], pagination: {...} }
            if (data.columns && Array.isArray(data.columns) && data.rows) {

                // Extraer nombres y deduplicar (la API devuelve cada columna duplicada)
                var seen = {};
                var colNames = [];
                data.columns.forEach(function (c) {
                    var name = c.columnName || c.name || c;
                    if (!seen[name]) {
                        seen[name] = true;
                        colNames.push(name);
                    }
                });

                // Total desde pagination o fallback
                var total = (data.pagination && data.pagination.totalRecords)
                    || data.totalRows
                    || data.total
                    || data.rows.length;

                $scope.tableData = { columns: colNames, rows: data.rows, total: total };
                $scope.pagination.total = total;
                $scope._backendHasNext = data.pagination ? data.pagination.hasNextPage  : null;
                $scope._totalPages     = data.pagination ? data.pagination.totalPages   : null;
                return;
            }

            // Shape B: { data: [...] }
            if (data.data && Array.isArray(data.data)) {
                var rows2 = data.data;
                var cols2 = rows2.length > 0 ? Object.keys(rows2[0]) : [];
                $scope.tableData = { columns: cols2, rows: rows2, total: data.total || rows2.length };
                $scope.pagination.total = $scope.tableData.total;
                $scope._backendHasNext = null;
                $scope._totalPages     = null;
                return;
            }

            // Shape C: array plano
            if (Array.isArray(data)) {
                var cols3 = data.length > 0 ? Object.keys(data[0]) : [];
                $scope.tableData = { columns: cols3, rows: data, total: data.length };
                $scope.pagination.total = data.length;
                $scope._backendHasNext = null;
                $scope._totalPages     = null;
                return;
            }

            $scope.tableData = { columns: [], rows: [], total: 0 };
        }

        // =====================================================
        // PAGINATION
        // =====================================================
        $scope.firstPage = function () {
            $scope.pagination.offset = 0;
            loadTableData();
        };

        $scope.prevPage = function () {
            $scope.pagination.offset = Math.max(0, $scope.pagination.offset - Number($scope.pagination.limit));
            loadTableData();
        };

        $scope.nextPage = function () {
            $scope.pagination.offset += Number($scope.pagination.limit);
            loadTableData();
        };

        $scope.lastPage = function () {
            if (!$scope._totalPages) return;
            $scope.pagination.offset = ($scope._totalPages - 1) * Number($scope.pagination.limit);
            loadTableData();
        };

        $scope.changePageSize = function () {
            $scope.pagination.offset = 0;
            loadTableData();
        };

        $scope.currentPage = function () {
            return Math.floor($scope.pagination.offset / Number($scope.pagination.limit)) + 1;
        };

        $scope.hasNextPage = function () {
            if ($scope._backendHasNext !== null && $scope._backendHasNext !== undefined) {
                return $scope._backendHasNext;
            }
            return $scope.tableData.rows && $scope.tableData.rows.length === Number($scope.pagination.limit);
        };

        $scope.retryLoad = function () {
            loadTableData();
        };

        // =====================================================
        // DATA SEARCH
        // El texto se busca en el servidor (contains, case-insensitive) sobre las
        // columnas visibles; la paginación y el total quedan sobre lo que matchea.
        // =====================================================
        $scope.searchData = function () {
            $scope.pagination.offset = 0;
            loadTableData();
        };

        $scope.clearDataSearch = function () {
            $scope.dataSearch.text = '';
            $scope.searchData();
        };

        $scope.isSearching = function () {
            return !!($scope.dataSearch.text || '').trim();
        };

        function _visibleColumnNames() {
            var tableRef = $scope.selectedTable && $scope.selectedTable.tableRef;
            if (!tableRef || !tableRef.attributes) return [];
            return tableRef.attributes
                .filter(function (attr) { return attr.visible !== false; })
                .map(function (attr) { return attr.columnName || attr.name || String(attr); });
        }

        // Con una búsqueda activa, mostrar u ocultar columnas cambia dónde se busca
        $scope.$watch(function () {
            return $scope.isSearching() ? _visibleColumnNames().join('\u0000') : null;
        }, function (current, previous) {
            if (current !== null && previous !== null && current !== previous) {
                $scope.searchData();
            }
        });

        // =====================================================
        // TREE FILTER HELPER
        // =====================================================
        $scope.treeFilterFn = function (schema) {
            return function (table) {
                if (!$scope.treeFilter) return true;
                var filter = $scope.treeFilter.toLowerCase();
                return table.name.toLowerCase().indexOf(filter) !== -1 ||
                    schema.name.toLowerCase().indexOf(filter) !== -1;
            };
        };

        // =====================================================
        // SELECTION HELPER
        // =====================================================
        $scope.isSelectedTable = function (schema, table) {
            return $scope.selectedTable &&
                $scope.selectedTable.schema === schema.name &&
                $scope.selectedTable.name === table.name;
        };

        // =====================================================
        // ATTRIBUTE ICON HELPERS
        // =====================================================
        var _typeIconMap = [
            { test: /int|bigint|smallint|tinyint|mediumint|serial|number/i, icon: 'tag',         cls: 'de-type-num'  },
            { test: /float|double|decimal|numeric|real|money/i,             icon: 'tag',         cls: 'de-type-num'  },
            { test: /date|time|timestamp|year/i,                            icon: 'event',       cls: 'de-type-date' },
            { test: /bool/i,                                                icon: 'toggle_on',   cls: 'de-type-bool' },
            { test: /json|jsonb|object|array/i,                             icon: 'data_object', cls: 'de-type-json' },
            { test: /uuid/i,                                                icon: 'fingerprint', cls: 'de-type-id'   },
            { test: /blob|bytes|binary/i,                                   icon: 'memory',      cls: 'de-type-bin'  }
        ];

        function _getTypeInfo(attr) {
            var type = ((attr && (attr.columnType || attr.dataType)) || '').toLowerCase();
            for (var i = 0; i < _typeIconMap.length; i++) {
                if (_typeIconMap[i].test.test(type)) return _typeIconMap[i];
            }
            return { icon: 'text_fields', cls: 'de-type-str' };
        }

        $scope.getAttrIcon = function (attr) {
            return _getTypeInfo(attr).icon;
        };

        $scope.getAttrIconClass = function (attr) {
            return _getTypeInfo(attr).cls;
        };

        // =====================================================
        // COLUMN ICON HELPERS  (used in data table header)
        // =====================================================
        $scope.getColIcon = function (colName) {
            var col = (colName || '').toLowerCase();
            if (/id$|_id$|^id/.test(col))                                   return 'fingerprint';
            if (/date|time|created|updated|modified|at$/.test(col))         return 'event';
            if (/amount|price|cost|total|qty|count|num|age|size/.test(col)) return 'tag';
            if (/status|state|type|flag|enabled|active/.test(col))          return 'toggle_on';
            if (/email/.test(col))                                          return 'email';
            if (/name|label|title|desc/.test(col))                          return 'text_fields';
            if (/json|data|meta|config|detail/.test(col))                   return 'data_object';
            return 'text_fields';
        };

        $scope.getColIconClass = function (colName) {
            var col = (colName || '').toLowerCase();
            if (/id$|_id$|^id/.test(col))                                   return 'de-type-id';
            if (/date|time|created|updated|modified|at$/.test(col))         return 'de-type-date';
            if (/amount|price|cost|total|qty|count|num|age|size/.test(col)) return 'de-type-num';
            return 'de-type-str';
        };

        // =====================================================
        // CELL VALUE FORMATTING
        // =====================================================
        $scope.formatCell = function (val) {
            if (val === null || val === undefined) return '';
            if (typeof val === 'object') {
                var s = JSON.stringify(val);
                return s.length > 60 ? s.substring(0, 57) + '…' : s;
            }
            var str = String(val);
            return str.length > 80 ? str.substring(0, 77) + '…' : str;
        };

        $scope.formatCellFull = function (val) {
            if (val === null || val === undefined) return 'NULL';
            if (typeof val === 'object') return JSON.stringify(val, null, 2);
            return String(val);
        };

        // =====================================================
        // JSON CELLS → biz-json-viewer (same overlay as the wizards' REQ / RES)
        // A cell is JSON when the value arrived as an object/array (the agent returns
        // json/jsonb columns as JSON trees) or its column is declared json.
        // =====================================================
        $scope.jsonViewer = { open: false, json: null, title: null };

        function _attrForColumn(colName) {
            var attrs = $scope.selectedTable && $scope.selectedTable.tableRef && $scope.selectedTable.tableRef.attributes;
            if (!attrs) return null;
            for (var i = 0; i < attrs.length; i++) {
                if ((attrs[i].columnName || attrs[i].name) === colName) return attrs[i];
            }
            return null;
        }

        $scope.isJsonCell = function (col, val) {
            if (val === null || val === undefined) return false;
            if (typeof val === 'object') return true;
            var attr = _attrForColumn(col);
            return !!attr && /json/i.test(attr.columnType || attr.dataType || '');
        };

        $scope.openJsonViewer = function (col, val, $event) {
            if ($event) $event.stopPropagation();
            $scope.jsonViewer = {
                open: true,
                json: val,
                query: $scope.highlightTerm,
                title: $scope.selectedTable.schema + '.' + $scope.selectedTable.name + ' · ' + col
            };
        };

        $scope.closeJsonViewer = function () {
            $scope.jsonViewer.open = false;
        };

        // Escape closes only the viewer, not the Data Explorer (md-dialog listens for Escape too)
        function _onKeydown(event) {
            if (event.key === 'Escape' && $scope.jsonViewer.open) {
                event.stopPropagation();
                $scope.$apply($scope.closeJsonViewer);
            }
        }
        document.addEventListener('keydown', _onKeydown, true);
        $scope.$on('$destroy', function () {
            document.removeEventListener('keydown', _onKeydown, true);
        });

        // Highlight the whole cell when the match is in a part it doesn't show (truncated text)
        $scope.hasHiddenMatch = function (val) {
            var contains = $filter('bmContains');
            return contains(val, $scope.highlightTerm) && !contains($scope.formatCell(val), $scope.highlightTerm);
        };

        $scope.getCellClass = function (col, val) {
            if (typeof val === 'number')  return 'de-val-num';
            if (typeof val === 'boolean') return 'de-val-bool';
            if (typeof val === 'object')  return 'de-val-json';
            var str = String(val);
            if (/^\d{4}-\d{2}-\d{2}/.test(str)) return 'de-val-date';
            if (/id$|_id$|^id/i.test(col))       return 'de-val-id';
            return '';
        };

        // =====================================================
        // COLUMN VISIBILITY HELPERS
        // =====================================================

        /**
         * Devuelve true si la columna debe mostrarse en la tabla de datos.
         * Busca el atributo correspondiente en la tabla seleccionada y lee
         * su flag `visible`. Si el atributo no se encuentra, muestra la columna.
         */
        $scope.isColumnVisible = function (colName) {
            if (!$scope.selectedTable || !$scope.selectedTable.tableRef) return true;
            var attrs = $scope.selectedTable.tableRef.attributes;
            if (!attrs || attrs.length === 0) return true;
            for (var i = 0; i < attrs.length; i++) {
                if ((attrs[i].columnName || attrs[i].name) === colName) {
                    return attrs[i].visible !== false;
                }
            }
            return true; // columna no encontrada en árbol → mostrar igual
        };

        /**
         * Cuenta cuántas columnas tienen visible === true en una tabla del árbol.
         */
        $scope.visibleColumnCount = function (table) {
            if (!table || !table.attributes) return 0;
            var count = 0;
            for (var i = 0; i < table.attributes.length; i++) {
                if (table.attributes[i].visible) count++;
            }
            return count;
        };

        /**
         * Devuelve true si TODAS las columnas de la tabla son visibles.
         */
        $scope.allColumnsVisible = function (table) {
            if (!table || !table.attributes || table.attributes.length === 0) return true;
            for (var i = 0; i < table.attributes.length; i++) {
                if (!table.attributes[i].visible) return false;
            }
            return true;
        };

        /**
         * Toggle-all: si todas son visibles las oculta (dejando la primera),
         * si alguna está oculta las muestra todas.
         * Detiene la propagación para no disparar selectTable.
         */
        $scope.toggleAllColumns = function (table, $event) {
            if ($event) $event.stopPropagation();
            if (!table || !table.attributes) return;
            var allVisible = $scope.allColumnsVisible(table);
            if (allVisible) {
                // Ocultar todas salvo la primera para evitar tabla vacía
                table.attributes.forEach(function (a, i) {
                    a.visible = (i === 0);
                });
            } else {
                // Mostrar todas
                table.attributes.forEach(function (a) {
                    a.visible = true;
                });
            }
        };

        // =====================================================
        // CLOSE
        // =====================================================
        $scope.closeDialog = function () {
            $mdDialog.hide();
        };

        // =====================================================
        // INIT
        // =====================================================
        loadSchemas();
    });